module.exports = __webpack_public_path__ + "img/DIJERON.8816a2b0.png";